import { ServiceDefinition } from '@pershing/pershing-core';

export class EquityTradingServiceDefinition implements ServiceDefinition {
    private static instance: ServiceDefinition = null;

    uri: string = 'trading/equity';
    version: string = 'v1';
    family: string = 'pershing';
    appName: string = 'equity-trading';
    serviceName: string = 'app';
    mnemonic: string = 'nxp';

    static getInstance(platform: string): ServiceDefinition {
        if (!EquityTradingServiceDefinition.instance) {
            EquityTradingServiceDefinition.instance = new EquityTradingServiceDefinition();
            if (platform === 'retail') {
                EquityTradingServiceDefinition.instance.family = 'netxinvestor';
                EquityTradingServiceDefinition.instance.mnemonic = 'nxc';
            }
        }
        return EquityTradingServiceDefinition.instance;
    }


    private constructor() {
        //intentional empty constructor
    }
}
